import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=40e062c3"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"
import style0 from "./Code.vue?vue&type=style&index=0&id=40e062c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports